module.exports = __webpack_public_path__ + "static/fonts/fa-brands-400.901a61b.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-brands-400.woff2
// module id = d1vH
// module chunks = 12